import { Component, OnInit, Renderer2, ViewChild } from "@angular/core";
import { Globals } from "@foh/globals";
import { ActivatedRoute } from "@angular/router";
import { ReservationformService } from "./reservationform.service";
import * as alertFunctions from "@foh/shared/data/sweet-alerts";
import * as utils from "@foh/shared/services/utils";
import { NgForm } from "@angular/forms";
import { NgbDatepicker } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-reservationform",
  templateUrl: "./reservationform.component.html",
  styleUrls: ["./reservationform.component.scss"]
})
export class ReservationformComponent implements OnInit {
  imageSrc: string;
  logoSrc: string;
  record: any;
  guests: any;
  branches: any;
  slots: any;
  routeObs$: any;
  token: string;
  startText: string = null;
  endText: string = null;
  showGuestsList: boolean = false;
  isTicketType: boolean = false;
  loading: boolean = false;
  availableSlots: boolean = false;
  minimumDate: any;
  maximumDate: any;
  ticketPrices: any;

  @ViewChild("f") newForm: NgForm;
  @ViewChild("d2") datePicker: NgbDatepicker;
  constructor(
    private activeRoute: ActivatedRoute,
    private renderer: Renderer2,
    private globals: Globals,
    private reservationformService: ReservationformService
  ) {
    //vpu7nf9l85xza3g
    //51bdijmphyzkasfv2c37w48le

    this.guests = [];
    this.branches = [];
    this.slots = [];

    var todayDate = new Date();
    var sevenDaysLater = new Date();
    sevenDaysLater.setDate(todayDate.getDate() + 7);
    this.minimumDate = {
      year: todayDate.getFullYear(),
      month: todayDate.getMonth() + 1,
      day: todayDate.getDate()
    };
    // this.maximumDate = {
    //   year: sevenDaysLater.getFullYear(),
    //   month: sevenDaysLater.getMonth() + 1,
    //   day: sevenDaysLater.getDate()
    // };
  }

  reset() {
    this.newForm.reset();
    this.record = {};
    setTimeout(() => {
      this.record.typeid = "1";
      this.record.pax = 2;
      this.record.gender = "m";
      var now = new Date();
      this.record.date = {
        year: now.getFullYear(),
        month: now.getMonth() + 1,
        day: now.getDate()
      };
      if (this.branches.length > 0) {
        this.record.branch_id = this.branches[0].id;
        this.updateSlots();
      }
    }, 50);
  }

  ngOnInit() {
    this.datePicker.minDate = this.minimumDate; //I am setting the value at component not the html because minDate [The DatePicker] was clashing with minDate [Ng2-validation]
    this.datePicker.maxDate = this.maximumDate; //I am setting the value at component not the html because maxDate [The DatePicker] was clashing with minDate [Ng2-validation]
    this.reset();
    this.logoSrc = this.globals.UPLOADS + "logos/fohlogo2.png";

    this.newGuest();
    this.routeObs$ = this.activeRoute.params.subscribe(params => {
      this.token = params["token"];
      this.record.fbscopeid = params["fbid"];
      this.reservationformService
        .retrieveMetadata(params)
        .subscribe((response: any) => {
          this.renderer.addClass(document.body, response.metaData.cssclass);
          this.imageSrc =
            this.globals.UPLOADS + "logos/" + response.metaData.logo;
          this.branches = response.branches;
          this.record.branch_id = this.branches[0].id;
          this.updateSlots();

          if (
            typeof response.metaData.starttext !== "undefined" &&
            response.metaData.starttext != "" &&
            response.metaData.starttext != null
          ) {
            this.startText = response.metaData.starttext;
          }
          if (
            typeof response.metaData.endtext !== "undefined" &&
            response.metaData.endtext != "" &&
            response.metaData.endtext != null
          ) {
            this.endText = response.metaData.endtext;
          }
        });
    });
  }

  newGuest() {
    var guest: any = {
      fname: "",
      lname: "",
      mobileno: "",
      email: "",
      fblink: "",
      gender:"m",
      contactmethod:"1"
    };
    this.guests.push(guest);
    this.record.pax = this.guests.length + 1;
  }

  removeGuest(index) {
    this.guests.splice(index, 1);
    this.record.pax = this.guests.length + 1;
  }

  recheckSlotGuestList() {
    var selectedSlot = this.getSlotById(this.record.slot_id);
    if (selectedSlot.ticketmode) {
      this.showGuestsList = true;
      this.isTicketType = true;
      this.injectTicketPrices(selectedSlot);
      return;
    } else {
      this.showGuestsList = false;
      this.isTicketType = false;
    }
    if (selectedSlot.guestlistmode || selectedSlot.guestlistfbonly) {
      this.showGuestsList = true;
      return;
    } else {
      this.showGuestsList = false;
    }
  }

  injectTicketPrices(selectedSlot){
    this.ticketPrices = selectedSlot.ticketprices;
  }

  getSlotById(id) {
    var found: any = false;
    if (id === null) {
      return found;
    }
    var slots = this.slots;
    for (var i = 0; i < slots.length; i++) {
      if (slots[i].id == id) {
        found = {};
        found = slots[i];
        break;
      }
    }
    return found;
  }

  updateGuestsList() {
    var currentGuestsPax = this.record.pax - 1;
    if (this.guests.length < currentGuestsPax) {
      for (var i = this.guests.length; i < currentGuestsPax; i++) {
        this.newGuest();
      }
    }
    if (this.guests.length > currentGuestsPax) {
      var i = this.guests.length;
      while (i--) {
        if (i >= currentGuestsPax) {
          this.removeGuest(i);
        }
      }
    }
  }

  updateSlotsDelayed() {
    setTimeout(() => {
      this.updateSlots();
    }, 40);
  }

  updateSlots() {
    for (var i = 0; i < this.branches.length; i++) {
      if (this.branches[i].id == this.record.branch_id) {
        this.slots = utils.filterSlotsPerDate(
          this.record.date,
          this.branches[i]["slots"],
          true
        );
        if (this.slots.length > 0) {
          this.record.slot_id = this.slots[0].id;
          this.availableSlots = true;
        } else {
          this.record.slot_id = null;
          this.availableSlots = false;
        }
        this.recheckSlotGuestList();
        break;
      }
    }
  }

  onSubmit() {
    if (!this.validate()) {
      return;
    }
    this.loading = true;
    this.reservationformService
      .addReservation({
        token: this.token,
        record: this.record,
        guests: this.guests
      })
      .subscribe(
        response => {
          this.loading = false;
          if (
            typeof response["guestsListIssues"] !== "undefined" &&
            response["guestsListIssues"].length > 0
          ) {
            alertFunctions.manageListIssues(
              "Reservation Request created with issues",
              response["guestsListIssues"]
            );
          } else {
            alertFunctions.success(
              "Reservation Request Added",
              "We have recieved your reservation request. We will contact you shorty."
            );
          }
          this.reset();
        },
        response => {
          this.loading = false;
        }
      );
  }

  validate() {
    //Validate Basic Data
    var basicData = true;

    //Validate Guestlist
    var guestlistData = this.validateGuestlist();

    return basicData && guestlistData;
  }

  validateGuestlist() {
    this.recheckSlotGuestList();
    if (!this.showGuestsList) {
      return true;
    }
    var sizeToCompare = this.guests.length + 1;
    if (sizeToCompare != this.record.pax) {
      //Size Error
      alertFunctions.error(
        "Guestlist Error",
        "The reservation guest list is incomplete. Please add all the guest in your party excluding yourself."
      );
      return false;
    }

    var arrayOfNames = [];
    var arrayOfMobiles = [];
    var arrayOfFbLinks = [];
    arrayOfNames.push(this.record.fname + " " + this.record.lname);
    arrayOfMobiles.push(this.record.mobileno);
    arrayOfFbLinks.push(this.record.fblink);

    //Make Sure ALl Guestnames are unique.
    for (var i = 0; i < this.guests.length; i++) {
      var fullname = this.guests[i].fname + " " + this.guests[i].lname;
      var checkFullName = arrayOfNames.indexOf(fullname);
      if (checkFullName === -1) {
        arrayOfNames.push(fullname);
      } else {
        alertFunctions.error(
          "Guestlist Error",
          "The Guestlist can not have repeating names/can not be the same name as the request host's name."
        );
        return false;
      }

      var checkMobiles = arrayOfMobiles.indexOf(this.guests[i].mobileno);
      if (checkMobiles === -1) {
        arrayOfMobiles.push(this.guests[i].mobileno);
      } else {
        alertFunctions.error(
          "Guestlist Error",
          "The Guestlist can not have repeating mobile numbers/can not be the same name as the request host's mobile number."
        );
        return false;
      }
    }
    return true;
  }
}
